module.exports = __webpack_public_path__ + "static/media/mainscreen-ashok-leyland.20884d2c.png";